/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
  "data": {
    "day": {
      "-1": "kaleessa",
      "0": "har’a",
      "1": "boru",
      "future": {
        "one": "guyyaa {0} keessatti",
        "other": "guyyoota {0} keessatti"
      },
      "past": {
        "one": "guyyaa {0} darbe",
        "other": "guyyoota {0} darban"
      }
    },
    "day-narrow": {
      "-1": "kaleessa",
      "0": "har’a",
      "1": "boru",
      "future": {
        "one": "g {0} keessatti",
        "other": "g {0} keessatti"
      },
      "past": {
        "one": "g {0} darbe",
        "other": "g {0} darbe"
      }
    },
    "day-short": {
      "-1": "kaleessa",
      "0": "har’a",
      "1": "boru",
      "future": {
        "one": "guyyaa {0} keessatti",
        "other": "guyyoota {0} keessatti"
      },
      "past": {
        "one": "guyyaa {0} darbe",
        "other": "guyyoota {0} darban"
      }
    },
    "hour": {
      "0": "sa’aatii kana",
      "future": {
        "one": "sa’aatii {0} keessatti",
        "other": "sa’aatiiwwan {0} keessatti"
      },
      "past": {
        "one": "sa’aatii {0} darbe",
        "other": "sa’aatiiwwan {0} darban"
      }
    },
    "hour-narrow": {
      "0": "sa’aatii kana",
      "future": {
        "one": "h {0} keessatti",
        "other": "h {0} keessatti"
      },
      "past": {
        "one": "h {0} darbe",
        "other": "h {0} darbe"
      }
    },
    "hour-short": {
      "0": "sa’aatii kana",
      "future": {
        "one": "sa. {0} keessatti",
        "other": "sa. {0} keessatti"
      },
      "past": {
        "one": "sa. {0} darbe",
        "other": "sa. {0} darbe"
      }
    },
    "minute": {
      "0": "this minute",
      "future": {
        "one": "daqiiqaa {0} keessatti",
        "other": "daqiiqaawwan {0} keessatti"
      },
      "past": {
        "one": "daqiiqaa {0} darbe",
        "other": "daqiiqaawwan {0} darban"
      }
    },
    "minute-narrow": {
      "0": "daqiiqaa kana",
      "future": {
        "one": "d {0} keessatti",
        "other": "d {0} keessatti"
      },
      "past": {
        "one": "d {0} darbe",
        "other": "d {0} darbe"
      }
    },
    "minute-short": {
      "0": "daqiiqaa kana",
      "future": {
        "one": "daq. {0} keessatti",
        "other": "daq. {0} keessatti"
      },
      "past": {
        "one": "daq. {0} darbe",
        "other": "daq. {0} darbe"
      }
    },
    "month": {
      "-1": "ji’a darbe",
      "0": "ji’a kana",
      "1": "ji’a dhufu",
      "future": {
        "one": "ji’a {0} keessatti",
        "other": "ji’oota {0} keessatti"
      },
      "past": {
        "one": "ji’a {0} darbe",
        "other": "ji’oota {0} darban"
      }
    },
    "month-narrow": {
      "-1": "ji. darbe",
      "0": "ji. kana",
      "1": "ji. dhufu",
      "future": {
        "one": "ji {0} keessatti",
        "other": "ji {0} keessatti"
      },
      "past": {
        "one": "ji {0} darbe",
        "other": "ji {0} darbe"
      }
    },
    "month-short": {
      "-1": "ji. darbe",
      "0": "ji. kana",
      "1": "ji. dhufu",
      "future": {
        "one": "ji. {0} keessatti",
        "other": "ji. {0} keessatti"
      },
      "past": {
        "one": "ji. {0} darbe",
        "other": "ji. {0} darbe"
      }
    },
    "nu": [
      "latn"
    ],
    "quarter": {
      "-1": "kurmaana darbe",
      "0": "kurmaana kana",
      "1": "kurmaana dhufu",
      "future": {
        "one": "kurmaana {0} keessatti",
        "other": "kurmaanota {0} keessatti"
      },
      "past": {
        "one": "kurmaana {0} darbe",
        "other": "kurmaanota {0} darban"
      }
    },
    "quarter-narrow": {
      "-1": "q darbe",
      "0": "q kana",
      "1": "q dhufu",
      "future": {
        "one": "q {0} keessatti",
        "other": "q {0} keessatti"
      },
      "past": {
        "one": "q {0} darbe",
        "other": "q {0} darbe"
      }
    },
    "quarter-short": {
      "-1": "kr. darbe",
      "0": "kr. kana",
      "1": "kr. dhufu",
      "future": {
        "one": "kr. {0} keessatti",
        "other": "kr. {0} keessatti"
      },
      "past": {
        "one": "kr. {0} darbe",
        "other": "kr. {0} darbe"
      }
    },
    "second": {
      "0": "amma",
      "future": {
        "one": "sekoondii {0} keessatti",
        "other": "sekoondiiwwan {0} keessatti"
      },
      "past": {
        "one": "sekoondii {0} darbe",
        "other": "sekoondiiwwan {0} darban"
      }
    },
    "second-narrow": {
      "0": "amma",
      "future": {
        "one": "s {0} keessatti",
        "other": "s {0} keessatti"
      },
      "past": {
        "one": "s {0} darbe",
        "other": "s {0} darbe"
      }
    },
    "second-short": {
      "0": "amma",
      "future": {
        "one": "sek. {0} keessatti",
        "other": "sek. {0} keessatti"
      },
      "past": {
        "one": "sek. {0} darbe",
        "other": "sek. {0} darbe"
      }
    },
    "week": {
      "-1": "torbee darbe",
      "0": "torbee kana",
      "1": "torbee dhufu",
      "future": {
        "one": "torbee {0} keessatti",
        "other": "torbanoota {0} keessatti"
      },
      "past": {
        "one": "torbee {0} darbe",
        "other": "torbanoota {0} darban"
      }
    },
    "week-narrow": {
      "-1": "tr. darbe",
      "0": "tr. kana",
      "1": "tr. dhufu",
      "future": {
        "one": "w {0} keessatti",
        "other": "w {0} keessatti"
      },
      "past": {
        "one": "w {0} darbe",
        "other": "w {0} darbe"
      }
    },
    "week-short": {
      "-1": "tr. darbe",
      "0": "tr. kana",
      "1": "tr. dhufu",
      "future": {
        "one": "tr. {0} keessatti",
        "other": "tr. {0} keessatti"
      },
      "past": {
        "one": "tr. {0} darbe",
        "other": "tr. {0} darbe"
      }
    },
    "year": {
      "-1": "waggaa darbe",
      "0": "waggaa kana",
      "1": "waggaa dhufu",
      "future": {
        "one": "waggaa {0} keessatti",
        "other": "waggoota {0} keessatti"
      },
      "past": {
        "one": "waggaa {0} dura",
        "other": "waggoota {0} dura"
      }
    },
    "year-narrow": {
      "-1": "wg. darbe",
      "0": "wg. kana",
      "1": "wg. dhufu",
      "future": {
        "one": "w {0} keessatti",
        "other": "w {0} keessatti"
      },
      "past": {
        "one": "w {0} dura",
        "other": "w {0} dura"
      }
    },
    "year-short": {
      "-1": "wg. darbe",
      "0": "wg. kana",
      "1": "wg. dhufu",
      "future": {
        "one": "wg. {0} keessatti",
        "other": "wg. {0} keessatti"
      },
      "past": {
        "one": "wg. {0} dura",
        "other": "wg. {0} dura"
      }
    }
  },
  "locale": "om"
})
}
